/* eslint-disable */

/**
 * Get the date format based on store region and feature flag.
 *
 * Returns lowercase keys matching the racstrap RACMUIDatePicker's internal
 * formatMap. The prop name on the picker is `dateFormat` (not `format`).
 * Keys must be fully lowercase — e.g. 'mm/dd/yyyy', 'dd/mm/yyyy'.
 *
 * @returns 'dd/mm/yyyy' for MX stores when flag is enabled, 'mm/dd/yyyy' otherwise
 */
export const getDateFormat = (
  storeDetails: any,
  featureFlagDetails: any
): string => {
  if (featureFlagDetails?.DateTimeLocalization !== '1') {
    return 'mm/dd/yyyy';
  }
  const countryAbb = storeDetails?.countryAbb?.toUpperCase();
  return countryAbb === 'MX' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';
};
